const LEVEL_DOT_COLORS: Record<string, string> = {
    alert: 'bg-red-500',
    warning: 'bg-amber-500',
    info: 'bg-blue-500',
    'goal-achieved': 'bg-emerald-500',
    none: 'bg-gray-400'
};

// Fill twins of the dot colours, for chart slices: SVG paints with fill, not background.
const LEVEL_DOT_FILLS: Record<string, string> = {
    alert: 'fill-red-500',
    warning: 'fill-amber-500',
    info: 'fill-blue-500',
    'goal-achieved': 'fill-emerald-500',
    none: 'fill-gray-400'
};

const LEVEL_BORDER_COLORS: Record<string, string> = {
    alert: 'border-l-red-400',
    warning: 'border-l-amber-400',
    info: 'border-l-blue-400',
    'goal-achieved': 'border-l-emerald-400',
    none: ''
};

const LEVEL_BG_COLORS: Record<string, string> = {
    alert: 'bg-red-50',
    warning: 'bg-amber-50',
    none: '',
    info: '',
    'goal-achieved': ''
};

const TYPE_LABELS: Record<string, string> = {
    ClinicalNotificationPublished: 'Clinical Notification',
    AlignerChangeInstructionSentToPatient: 'Aligner Change',
    AlignerReachedInfoSentToPatient: 'Aligner Milestone Reached',
    ComfortScanPublished: 'Comfort Scan Uploaded',
    PatientMonitoringStarted: 'Monitoring Started',
    PatientMonitoringPaused: 'Monitoring Paused',
    PatientMonitoringResumed: 'Monitoring Resumed',
    PatientMonitoringStopped: 'Monitoring Stopped',
    MessageSentToTeam: 'Team message',
    SupportSentMessageAboutPatient: 'DM Support message',
    PatientAppNotActivated: 'App not activated',
    TimeframeNotificationPublished: 'Timeframe notification',
    PatientAlignersModifiedByPatient: 'Aligners changed by patient',
    PatientAlignersModifiedByDoctor: 'Aligners changed by doctor'
};

export function getEventLabel(type: string): string {
    return TYPE_LABELS[type] ?? type;
}

export function getDotColor(level: string): string {
    return LEVEL_DOT_COLORS[level] ?? LEVEL_DOT_COLORS.none;
}

export function getDotFill(level: string): string {
    return LEVEL_DOT_FILLS[level] ?? LEVEL_DOT_FILLS.none;
}

export function getBorderColor(level: string): string {
    return LEVEL_BORDER_COLORS[level] ?? '';
}

export function getBgColor(level: string): string {
    return LEVEL_BG_COLORS[level] ?? '';
}
